<template>
  <div>
    <page-heading-info
    title="Jefferson County Employee Resources"
    ></page-heading-info>

    <text-box-title title="External Resources">
      <ul style="margin-left: 2em;">
        <li><a class="ml-3 mr-3 mt-3" href="https://aetnaresource.com/p/Jefferson-County-Government">
          Jefferson county government member resources
        </a></li>
        <li><a class="ml-3 mr-3 mt-3" href="https://youtu.be/qrRCPPjVat0">
          Training video for the county's new phone system
        </a></li>
        <li><a class="ml-3 mr-3 mt-3" href="https://jeffersoncountyoh.com/static/documents/184/258261138_Snom_D735_Reference_Guide_Checkmark_Required.pdf">
          Phone Reference Guide: Model D735
        </a></li>
        <li><a class="ml-3 mr-3 mt-3" href="https://jeffersoncountyoh.com/static/documents/229/258261138_Snom_D785_Reference_Guide_Checkmark_Required.pdf">
          Phone Reference Guide: Model D785
        </a></li>
      </ul>
    </text-box-title>

    <text-box-title title="Health Plan Documents">
      <note-documents class="ml-3 mr-3 mt-3" note-id="17"></note-documents>
    </text-box-title>

    <text-box-title title="Employee Manuals">
      <note-documents class="ml-3 mr-3 mt-3" note-id="18"></note-documents>
    </text-box-title>


    <!--
    <text-box-title title="OPERS Health Care Information">
      <div class="col mt-3">
      <h4>Town Hall meetings</h4>
      <p>
        This combined pension and health care proposed changes. <a href="https://www.opers.org/seminars/townhallandsurvey.shtml">https://www.opers.org/seminars/townhallandsurvey.shtml</a>
      </p>

      <h4>Town Hall meetings</h4>
      <p>
        This combined pension and health care proposed changes. <a href="https://www.opers.org/seminars/townhallandsurvey.shtml">https://www.opers.org/seminars/townhallandsurvey.shtml</a>
      </p>

      <h4>Town Hall meetings</h4>
      <p>
        This combined pension and health care proposed changes. <a href="https://www.opers.org/seminars/townhallandsurvey.shtml">https://www.opers.org/seminars/townhallandsurvey.shtml</a>
      </p>

      <h4>Town Hall meetings</h4>
      <p>
        This combined pension and health care proposed changes. <a href="https://www.opers.org/seminars/townhallandsurvey.shtml">https://www.opers.org/seminars/townhallandsurvey.shtml</a>
      </p>
      </div> 
    </text-box-title>
    -->

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import CollapseView from '@/components/display-utils/CollapseView.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import LinkBox from '@/components/layout/LinkBox.vue'
import NoteDocuments from '@/components/display-utils/NoteDocuments.vue'

export default {
  components: {
    PageHeadingInfo,
    CollapseView,
    TextBoxTitle,
    LinkBox,
    NoteDocuments
  },
  data () {
    return {}
  }
}
</script>

<style>

</style>

